/* eslint-disable react/jsx-props-no-spreading, import/prefer-default-export */
import React from 'react';
import {
  ErrorBox,
  ErrorMessage,
  ErrorTitle,
  FormDialog,
  FormElement,
  FormInputsStack,
  FormDialogTitle,
  FormDialogContent,
  FormDialogActions,
  FormCancelButton,
  FormSubmitButton,
  Inputs,
  InputComboBoxObjectOption,
  ComboBoxOption,
} from '@marageti/z4-lib';
import { Controller } from 'react-hook-form';
import { Props } from './types';

const EditForm = ({
  control,
  countryOptions,
  riskLevelOptions,
  editorState,
  errors,
  handleSubmit,
  onCancel,
  onSubmit,
  open,
  register,
  submissionError,
}: Props) => (
  <FormDialog
    open={open}
  >
    <FormDialogTitle handleClose={onCancel}>
      {editorState.country ? `Edit ${editorState.country} Setting` : 'New Default Setting'}
    </FormDialogTitle>
    <FormElement name="edit-country-settings" onSubmit={handleSubmit(onSubmit)}>
      <FormDialogContent>
        <FormInputsStack>
          { !editorState.country && (
            <Controller
              key="country"
              control={control}
              name="country"
              render={({ field }) => (
                <InputComboBoxObjectOption
                  error={!!errors?.country}
                  helperText={errors?.country?.message as string}
                  id="country"
                  label="Country"
                  options={countryOptions}
                  {...field}
                  onChange={(_: any, data: ComboBoxOption | null) => {
                    field.onChange(data);
                  }}
                  value={field.value || null}
                />
              )}
              rules={{ required: 'Please select a country' }}
            />
          )}
          <Inputs.Number
            error={!!errors?.minBudgetPPPD}
            helperText={errors?.minBudgetPPPD && 'Please enter a number greater than 0'}
            id="minBudgetPPPD"
            label="Minimum Per Person"
            required
            startAdornment={<Inputs.Adornment position="start">$</Inputs.Adornment>}
            {...register('minBudgetPPPD', { required: 'Please enter a Budget Minimum' })}
          />
          <Inputs.Number
            error={!!errors?.minNights}
            id="minNights"
            label="Minimum Nights"
            required
            {...register('minNights', { required: 'Please enter a Minimum Nights' })}
          />
          <Inputs.Number
            error={!!errors?.minCharCount}
            id="minCharCount"
            label="Minimum Description Length (Characters)"
            required
            {...register('minCharCount', { required: 'Please enter a Minimum Length' })}
          />
          <Inputs.Number
            error={!!errors?.maxMonths}
            helperText="Trip requests will be flagged if the departure date exceeds the specified period above."
            id="maxMonths"
            label="Maximum Planning Time (Months)"
            required
            {...register('maxMonths', { required: 'Please enter a Maximum' })}
          />
          <Controller
            key="originRiskRating"
            control={control}
            name="originRiskRating"
            rules={{ required: 'Please select a risk rating' }}
            render={({ field }) => (
              <InputComboBoxObjectOption
                error={!!errors?.originRiskRating}
                helperText={errors?.originRiskRating?.message as string}
                id="originRiskRating"
                label="Origin Risk Rating"
                isOptionEqualToValue={(option1, option2) => {
                  if (typeof option2 === 'string') {
                    return option1.value === option2;
                  }
                  return option1.value === option2?.value;
                }}
                options={riskLevelOptions}
                {...field}
                onChange={(_: any, data: ComboBoxOption | null) => {
                  field.onChange(data);
                }}
                value={field.value || null}
              />
            )}
          />
        </FormInputsStack>
        {submissionError && (
          <ErrorBox>
            <ErrorTitle>
              There was an error on our end.
            </ErrorTitle>
            <ErrorMessage>
              {`Code: ${submissionError.code}: ${submissionError.message}`}
            </ErrorMessage>
          </ErrorBox>
        )}
      </FormDialogContent>
      <FormDialogActions>
        <FormCancelButton onClick={onCancel} />
        <FormSubmitButton>
          Submit
        </FormSubmitButton>
      </FormDialogActions>
    </FormElement>
  </FormDialog>
);

export {
  EditForm,
};
